import axios from 'axios'
import store from '@/store/index'

let baseURL = '/loan/jxt'
// const api = ' '
export function request(config) {
  // 1.创建axios的实例
  const instance = axios.create({
    baseURL,
    timeout: 5000
  })

  // 2.axios的拦截器
  // 2.1.请求拦截的作用
  instance.interceptors.request.use(config => {
    const ticket = store.state.ticket
    config.headers['gxdjkey'] = ticket || ''
    return config
  }, err => {
    console.log(err);
  })

  // 2.2.响应拦截
  instance.interceptors.response.use(res => {
    return res.data
  }, err => {
    if (err.response.status === 402) {
      store.commit('UPDATE_TICKET', '')
      location.href = location.origin + location.pathname
    }
  })

  // 3.发送真正的网络请求
  return instance(config)
}
